import {connect} from 'react-redux'
import {push} from 'connected-react-router'
import {
    workHistoryDetailsSelect,
    populateWorkHistoryListDataForReview
} from '../../redux/selector/workHistoryDetailsSelector'

import {setCurrentAgentWorkHistoryDetails} from '../../redux/slice/additionalApplicationsSlice'
import {
    Header, 
    Paragraph, 
    Button,
    NavigationLinkButton,
    LineSeperator,
    ErrorMark,
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import TopNavigationBar from "../TopNavigationBar"
import { useEffect, useState } from 'react'
import WorkHistoryDetailsForm from '../../components/WorkDetails/WorkHistoryDetailsForm'
import {
    VIEW_MODE_REGULAR,
    APPLICATION_MODE_RENEW,
    APPLICATION_TYPE_COLLECTOR,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
    ROUTE_PATH,
} from '../../app/constants'
import { replaceUrlParams } from '../../app/utils';
import Navigation from '../Navigation'
import { ERROR_STRING } from '../../app/errors'
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice'
import { setAgencyWorkHistoryDetails } from '../../redux/slice/primaryAgencyApplicationSlice'

const WorkHistoryDetails = (props) => {
    
    const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const collectorApplicantDetails = props.workHistoryDetails.collectorApplicantDetails
    const workHistoryDetails = props.workHistoryDetails[applicationType] ? 
        props.workHistoryDetails[applicationType] : props.workHistoryDetails
    const [showValidationError, setShowValidationError] = useState(false)
    const [applicationSaveError, setApplicationSaveError] = useState(false)
    // const [allPeopleNotCoveredError, setAllPeopleNotCoveredError] = useState(VALIDATION_ERROR.NO_ERROR)

    const defaultHistoryDetailObject = () => {
        return {
            people : "",
            description : ""
        }
    }

    let details = []
    if(props.workHistoryDetails.workHistoryList &&
        Array.isArray(props.workHistoryDetails.workHistoryList)
        && props.workHistoryDetails.workHistoryList.length > 0 
    ) {
        details = props.workHistoryDetails.workHistoryList
    } else { 
        details.push(defaultHistoryDetailObject())
    }

    const [historyDetails, setHistoryDetails] = useState(details)

    const [viewMode,setViewMode] = useState(props.viewMode ? 
        props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
            VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

    const validateData = () => {

        for(let i =0; i < historyDetails.length; i++) { 
            const wH = historyDetails[i]

            if(!wH.people || !wH.people.firstName)
                return false

            if(!wH.description)
                return false
        }

        // Fix for MRA-465 - remove validation for the all people covered or not.
        // const filterNameList = props.workHistoryDetails.peopleList.filter((p) => {
        //     return (historyDetails.findIndex((d) => d.people.entityId === p.entityId) === -1)
        // })

        // if(filterNameList.length > 0) { 
        //     setAllPeopleNotCoveredError(VALIDATION_ERROR.INCOMPLETE_PEOPLE_LIST)
        //     return false
        // }

        return true
    }

    const isPeopleListComplete = () => { 
        // if(showValidationError) { 
        //     return (allPeopleNotCoveredError === VALIDATION_ERROR.NO_ERROR)
        // }

        return true
    }

    const onNextClick =() => {

        setApplicationSaveError(false)

        if(!validateData()) { 
            setShowValidationError(true)
            return
        }

        if(applicationType === APPLICATION_TYPE_COLLECTOR || 
            applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
            dispatch(setCurrentAgentWorkHistoryDetails(historyDetails))
        } else { 
            dispatch(setAgencyWorkHistoryDetails(historyDetails))
        }

        /*
        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then((data) => {
                props.dispatch(push(replaceUrlParams(addressForService.navigation.next, applicationType, applicationMode)))
            })  
            .catch(err => {
                setApplicationSaveError(true)
            })
        */
        
        dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then(data => {
                let nextUrl = workHistoryDetails.navigation.next
                if(props.workHistoryDetails.licenceSuspendedData
                    && Array.isArray(props.workHistoryDetails.licenceSuspendedData)
                    && props.workHistoryDetails.licenceSuspendedData.length > 0) 
                { 
                        nextUrl = ROUTE_PATH.LICENCE_SUSPENSION_DETAILS
                }
        
                if((viewMode === VIEW_MODE_RENEWAL_PREVIEW || viewMode === VIEW_MODE_RENEWAL_EDIT)
                    && workHistoryDetails.navigation.nextRenewal) {
                    nextUrl = workHistoryDetails.navigation.nextRenewal
                }
                dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
            })
            .catch(err => {
                setApplicationSaveError(true)
            })
    }

    const onDetailsChange = (update) => {
        let index = parseInt(update.id)
        let updatedHistoryDetails = [...historyDetails]
        let updatedDetails = Object.assign({}, historyDetails[index], update.updatedDetails)
        updatedHistoryDetails.splice(index, 1,updatedDetails)
        setHistoryDetails(updatedHistoryDetails)
    }

    let historyComponents = []

    historyDetails.forEach((element, key) => {
        historyComponents.push(
            <div key={key} className="bottomMarginNormal">
                <div className={"bottomMarginNormal"}>
                    <div className="row">
                        <div className="col-8">
                            <WorkHistoryDetailsForm 
                                id={key} 
                                onDetailsChange={onDetailsChange}
                                people={element.people}
                                description={element.description}
                                showValidationError={showValidationError} 
                                peopleList={props.workHistoryDetails.peopleList}
                            />
                        </div>
                        <div className={"col-4"}>
                            <NavigationLinkButton
                                    id={"work-history-remove-link"}
                                    text={"- Remove work history "}
                                    onClick={() => {
                                        let details = [...historyDetails]
                                        details.splice(key, 1)
                                        setHistoryDetails(details)
                                    }}
                            />
                        </div>
                    </div>
                </div>
                <LineSeperator />
            </div>
        )
    });

    let reviewData = []
    if(viewMode === VIEW_MODE_RENEWAL_PREVIEW)
        reviewData = populateWorkHistoryListDataForReview(details)

    let collectorName = "Collector"

    if(collectorApplicantDetails && collectorApplicantDetails.firstName) {
        collectorName = collectorApplicantDetails.firstName
    }

    let paragraphText = (viewMode === VIEW_MODE_RENEWAL_PREVIEW) ? 
        workHistoryDetails.textRenewal : workHistoryDetails.text
    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
        paragraphText = paragraphText.map((text) => text.replace("<collector_name>",collectorName))
    }

    useEffect(() => {

        let details = []

        if(props.workHistoryDetails.workHistoryList &&
            Array.isArray(props.workHistoryDetails.workHistoryList)
            && props.workHistoryDetails.workHistoryList.length > 0 
        ) {
            details = props.workHistoryDetails.workHistoryList
        } else { 
            details.push(defaultHistoryDetailObject())
        }

        setHistoryDetails(details)

    }, [props.workHistoryDetails,setHistoryDetails])

    return(
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT !== viewMode &&
                <>
                    <TopNavigationBar {...props} />
                    <div className="row">
                        <div className={"col-lg-8"}>
                            <Header 
                                id="work-history-details-header" 
                                header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? 
                                        workHistoryDetails.headerRenewal : workHistoryDetails.header} />
                            <Paragraph 
                                id="work-history-details-text"
                                text={paragraphText} />
                        </div>
                    </div>
                </>
                }
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                        <>
                            {
                                reviewData.map((data, index) => {
                                    return (
                                        <div key={"review-work-history-data-" + index}>
                                            <ReviewForm data={data} />
                                            {(index < reviewData.length - 1)
                                                && <LineSeperator />} 
                                        </div>
                                    )
                                })
                            }
                        </>
                        }
                        {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                            historyComponents
                        }
                    </div>
                </div>

                {viewMode !== VIEW_MODE_RENEWAL_PREVIEW && 
                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-8"}>
                            <NavigationLinkButton
                                id={"worky-history-add-more-link"}
                                text={"+ Add another work history"}
                                onClick={() => {
                                    setShowValidationError(false)
                                    let historyDetailUpdate = [...historyDetails, defaultHistoryDetailObject()]
                                    setHistoryDetails(historyDetailUpdate)
                                }}
                            />
                        </div>
                    </div>
                }

                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT !== viewMode &&
                    <div className="row bottomMarginNormal">
                        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                            <Button 
                                id="preview-before-submit-next-button"
                                text={"Save and next"}
                                buttonType={"regular_primary"}
                                onClick={onNextClick}
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && <div className="help-block topMarginNormal">
                                {ERROR_STRING.APPLICATION_SAVE_ERROR}
                            </div>}
                        </div>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <div className="col-lg-4">
                            <NavigationLinkButton 
                                id={"work-history-details-edit-mode-switch"}
                                text={"Update this information before continuing"}
                                onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                            />
                        </div>}
                    </div>
                }
                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT === viewMode &&
                    <div className="row bottomMarginNormal">
                        <div className={"col-lg-8" + (!isPeopleListComplete() ? " has-error" : "")}>
                            <Button 
                                id="preview-before-submit-save-button"
                                text={"Save"}
                                buttonType={"regular_primary"}
                                onClick={() => {
                                    
                                    if(!validateData()) { 
                                        setShowValidationError(true)
                                        return
                                    }

                                    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
                                        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
                                        dispatch(setCurrentAgentWorkHistoryDetails(historyDetails))
                                    } else { 
                                        dispatch(setAgencyWorkHistoryDetails(historyDetails))
                                    }
                                    props.onEditSave()
                                }}
                            />
                            {!isPeopleListComplete() && ErrorMark()}
                            {!isPeopleListComplete() && <div className="help-block">
                                {ERROR_STRING.WORK_HISTORY_INCOMPLETE_PEOPLE_LIST}
                            </div>}
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default connect(workHistoryDetailsSelect)(WorkHistoryDetails)
